export const initialQuickLookSettings = {
    "BundleReceivedInManifest": [
        "bundle_name",
        "type"
    ],
    "ServerSynchronizationTriggered": [
        "reason_sync",
        "cm_social_id",
        "global_user_id"
    ],
    "clientLoadingStepCompleted": [
        "state_name"
    ],
    "gameStateExit": [
        "state_name"
    ],
    "purchaseCompleteNotValidated": [
        "store_id",
        "price"
    ],
    "rubyPurchase": [
        "amount",
        "group_id",
        "offer_id",
        "type",
        "product_id"
    ],
    "itemPurchase": [
        "group_id",
        "offer_id",
        "product_id"
    ],
    "inappPurchase": [
        "content"
    ],
    "offersPurchase": [
        "offer_type"
    ],
    "TownLoadingFunnel": [
        "bundleId",
        "name",
        "step"
    ],
    "users": [
        "os",
        "device_model",
        "cm_social_id",
        "clan",
        "wins",
        "device_name",
        "screen_size",
        "firebase_id",
        "current_version",
        "games",
        "dev_build",
        "adjust_id",
        "email",
        "sn"
    ],
    "AdjustInitCallback": [
        "result",
        "adjust_id"
    ],
    "levelStart": [
        "group_id",
        "level_id",
        "lives",
        "start_ruby",
        "bundle_id",
        "chain_id",
        "house_id",
        "extra_moves_booster"
    ],
    "syncFail": [
        "reason"
    ],
    "userEnvironment": [
        "device_brand",
        "device_product",
        "os",
        "device_model",
        "total_ram_size"
    ],
    "purchaseStatus": [
        "status"
    ],
    "contentModelCreated": [
        "content_type",
        "content_id",
        "content_start",
        "content_end"
    ],
    "advertInitialize": [
        "cohort"
    ],
    "advertInitializeSuccess": [
        "cohort"
    ],
    "advertLoad": [
        "ad_type",
        "cohort"
    ],
    "contentStartFailed": [
        "content_id",
        "content_type",
        "reason"
    ],
    "advertLoadSuccess": [
        "ad_type",
        "cohort",
        "grid"
    ],
    "advertIdGenerated": [
        "ad_type",
        "cohort",
        "grid"
    ],
    "offersIconClick": [
        "offer_id",
        "cohort",
        "smart_cohort",
        "rubies"
    ],
    "bpNewWindowOpen": [
        "offer_id"
    ],
    "bpNewPrizeCollected": [
        "offer_id",
        "level_id",
        "level_type",
        "bp_type"
    ],
    "briefingLevelStart": [
        "level_id",
        "house_id",
        "group_id",
        "id"
    ],
    "levelBannerStart": [
        "ad_type",
        "cohort",
        "level_id",
        "saga_level"
    ],
    "fpsReport": [
        "median_fps",
        "game_mode"
    ],
    "itemSpend": [
        "amount",
        "reason",
        "ruby_price",
        "type",
        "level_id"
    ],
    "advertDisplay": [
        "ad_type",
        "cohort",
        "group_id"
    ],
    "levelBannerDisplay": [
        "ad_type",
        "cohort",
        "level_id"
    ],
    "advertDisplaySuccess": [
        "ad_type",
        "cohort",
        "grid"
    ],
    "levelBannerDisplaySuccess": [
        "ad_type",
        "cohort"
    ],
    "advertActionShow": [
        "ad_type",
        "source",
        "cohort",
        "placement"
    ],
    "levelWin": [
        "group_id",
        "bundle_id",
        "chain_id",
        "level_id",
        "turns_left",
        "ruby_spend",
        "start_ruby",
        "location",
        "lightning_used"
    ],
    "levelWinBlocker": [
        "group_id",
        "level_id",
        "blocker_id",
        "amount"
    ],
    "levelWinBooster": [
        "group_id",
        "booster_id",
        "amount",
        "type"
    ],
    "materialPurchase": [
        "type",
        "amount",
        "screen",
        "source",
        "mode",
        "group_id",
        "level_id",
        "house_id",
        "location"
    ],
    "houseMaterials": [
        "house",
        "material",
        "gathered",
        "required",
        "reason",
        "saga_challenge",
        "quest_id",
        "stage"
    ],
    "piggyBankAddRuby": [
        "piggy_level",
        "ruby_count",
        "offer_id",
        "ruby_amount"
    ],
    "bpNewTokenGet": [
        "offer_id",
        "amount",
        "group_id",
        "source",
        "complexity_multiplier_score",
        "boost_x_score",
        "bp_type"
    ],
    "UniqueBoosterProgress": [
        "unique_booster_progressbar",
        "winstreak",
        "unique_booster_count",
        "unique_booster_type",
        "cohort",
        "offer_id"
    ],
    "wcTokenGet": [
        "amount",
        "total_amount",
        "group_id",
        "level_id",
        "offer_id",
        "bundle_id",
        "cohort"
    ],
    "ManifestUpdate": [
        "ignored",
        "remote"
    ],
    "advertDismiss": [
        "ad_type",
        "cohort"
    ],
    "levelBannerDisplayStop": [
        "ad_type",
        "cohort",
        "level_id",
        "saga_level"
    ],
    "victoryLevelPopupShow": [
        "ruby_balance",
        "with_bomb"
    ],
    "advertActionClick": [
        "placement",
        "cohort",
        "ad_type",
        "source"
    ],
    "windowClose": [
        "reason"
    ],
    "advertActionWatch": [
        "ad_type",
        "source",
        "cohort",
        "grid",
        "placement"
    ],
    "advertReward": [
        "ad_type",
        "cohort",
        "grid"
    ],
    "advertActionWatchSuccess": [
        "ad_type",
        "source",
        "cohort",
        "grid",
        "placement"
    ],
    "endSession": [
        "session_id",
        "sessionPerDay",
        "lives",
        "ulives",
        "smart_cohort",
        "smart_cohort_previous"
    ],
    "init": [
        "bonus_blast",
        "bonus_star",
        "bonus_lightning",
        "payLive",
        "puzzlePiece",
        "ruby",
        "trick_hummer",
        "trick_bomb",
        "trick_color",
        "trick_glove",
        "bonus_blast_usd",
        "bonus_star_usd",
        "bonus_lightning_usd",
        "payLive_usd",
        "ruby_usd",
        "trick_hummer_usd",
        "trick_bomb_usd",
        "trick_color_usd",
        "usd_rating",
        "trick_glove_usd",
        "infinity_lives",
        "booster_blast",
        "booster_star",
        "booster_lightning",
        "m3turns_pack",
        "mate_dog",
        "mate_cat",
        "mate_parrot",
        "mate_monkey",
        "saga_x2",
        "tt_x2",
        "first_try_wins",
        "material_saga_total",
        "lives_sent",
        "lives_received",
        "materials_sent",
        "materials_received",
        "saga_wins",
        "total_wins",
        "houses_unlocked"
    ],
    "collectionConsumables": [
        "payload"
    ],
    "victoryLevelPopupClick": [
        "with_bomb",
        "ruby_balance",
        "type"
    ],
    "levelStats": [
        "group_id",
        "bundle_id",
        "chain_id",
        "level_id",
        "version",
        "moves_made",
        "moves_left",
        "bomb",
        "star",
        "lightning",
        "start_ruby",
        "match_manual",
        "match_auto",
        "match_auto_chips",
        "blockers",
        "red",
        "green",
        "blue",
        "yellow",
        "orange",
        "emerald",
        "result",
        "pink",
        "red_collected",
        "blue_collected",
        "green_collected",
        "yellow_collected",
        "orange_collected",
        "emerald_collected",
        "pink_collected",
        "petard_collected",
        "required_chips_first",
        "type_chips_first",
        "goal_chips_first",
        "blast_preview",
        "star_preview",
        "blast_activated",
        "blast_activated_tap",
        "blast_activated_manual",
        "blast_activated_automatch",
        "star_activated",
        "star_activated_tap",
        "star_activated_manual",
        "star_activated_automatch",
        "lightning_activated",
        "lightning_activated_tap",
        "lightning_activated_manual",
        "lightning_activated_automatch",
        "level_attempt_global",
        "level_attempt_noexit",
        "drop_help_enabled",
        "abnormalies_flag",
        "type_chips_second",
        "required_chips_second",
        "goal_chips_second",
        "type_chips_3",
        "required_chips_3",
        "goal_chips_3",
        "lightning_preview",
        "no_help",
        "help",
        "mate_id",
        "moves_start",
        "extra_moves_booster",
        "location",
        "complexity_multiplier_score",
        "boost_x_score",
        "complexity",
        "clan_cohort",
        "clan_levels",
        "loop_moves_limit_min",
        "loop_moves_limit_max",
        "loop_moves_coef",
        "loop_moves_force_limit_min",
        "loop_moves_force_limit_max",
        "moves_by_design"
    ],
    "defeatLevelPopupShow": [
        "type",
        "with_bomb",
        "ruby_balance",
        "last_chance",
        "more_moves"
    ],
    "offersPlacementShow": [
        "product_id",
        "source_buy",
        "offer_type",
        "cohort",
        "offer_id"
    ],
    "defeatLevelPopupClick": [
        "type",
        "with_bomb",
        "last_chance",
        "ruby_balance",
        "more_moves",
        "click_type"
    ],
    "reasonLevelContinue": [
        "type",
        "with_bomb",
        "ruby_balance",
        "last_chance",
        "more_moves",
        "return_type",
        "bp_offer",
        "defeat_number",
        "exit_type",
        "defeat_type",
        "prize_piece"
    ],
    "actionExecute": [
        "action",
        "auto_open_type",
        "offer_type",
        "offer_id"
    ],
    "wcWindowOpen": [
        "offer_id",
        "bundle_id",
        "cohort"
    ],
    "piggyBankOfferShow": [
        "piggy_level",
        "ruby_count",
        "last_chance",
        "type_chance",
        "full",
        "offer_id"
    ],
    "offersShow": [
        "offer_id",
        "cohort",
        "smart_cohort",
        "rubies",
        "orientation",
        "offer_type",
        "last_chance"
    ],
    "piggyBankRefuse": [
        "piggy_level",
        "last_chance",
        "type_chance",
        "full",
        "ruby_count",
        "offer_id"
    ],
    "scHudClick": [
        "offer_id",
        "cohort"
    ],
    "scMainWindowOpen": [
        "offer_id",
        "cohort"
    ],
    "advertLoadFailure": [
        "ad_type",
        "cohort"
    ],
    "scDuplicateShopOpen": [
        "offer_id",
        "cohort",
        "collection"
    ],
    "scDuplicateShopClick": [
        "collection",
        "offer_id",
        "cohort"
    ],
    "scStarGet": [
        "offer_id",
        "cohort",
        "collection",
        "amount",
        "star"
    ],
    "scPackGet": [
        "type",
        "gold",
        "source",
        "amount",
        "pack",
        "offer_id",
        "cohort",
        "collection",
        "star"
    ],
    "scStarSpend": [
        "sn",
        "amount",
        "collection",
        "type",
        "offer_id",
        "cohort"
    ],
    "clanLifeGet": [
        "clan",
        "user_send",
        "clan_cohort",
        "clan_levels"
    ],
    "exitPopupPreDefeat": [
        "from_confirmation"
    ],
    "levelLoss": [
        "group_id",
        "level_id",
        "chain_id",
        "bundle_id",
        "version",
        "adjustment",
        "reason",
        "help",
        "objective",
        "complexity",
        "objectives_full",
        "objectives_left",
        "ruby_spend",
        "loop_moves_force_limit_max",
        "loop_moves_force_limit_min",
        "loop_moves_limit_min",
        "loop_moves_limit_max",
        "loop_moves_coef",
        "moves_through",
        "complexity_multiplier_score",
        "onboarding",
        "boost_x_score",
        "drop_help_enabled",
        "level_attempt_noexit",
        "level_attempt_global",
        "uhummer",
        "uglove",
        "ucolor",
        "ubomb",
        "location",
        "extra_moves_booster",
        "shafls",
        "start_ruby",
        "ulightning",
        "ustar",
        "ublast",
        "ulive",
        "mate_id",
        "mate_used",
        "lives",
        "game_id"
    ],
    "materialSpend": [
        "type",
        "amount",
        "mode",
        "screen",
        "house_id",
        "reason",
        "group_id",
        "level_id"
    ],
    "dialogStart": [
        "story_id",
        "dialog_id",
        "house"
    ],
    "dialogEnd": [
        "story_id",
        "dialog_id",
        "reason_close"
    ],
    "UniqueBoosterLevelStart": [
        "group_id",
        "level_id",
        "cohort",
        "unique_booster_count",
        "unique_booster_type",
        "offer_id"
    ],
    "advertClick": [
        "ad_type",
        "cohort",
        "grid"
    ],
    "houseDisenchant": [
        "house",
        "prev_level",
        "curr_level"
    ],
    "userEnvironmentDynamic": [
        "available_ram_size"
    ],
    "clientLoadingStarted": [
        "session_version"
    ],
    "minigameBubble": [
        "level_id",
        "level_type",
        "house_id",
        "offer_id",
        "cohort"
    ],
    "clientLoadingCompleted": [
        "time"
    ],
    "UniqueBoosterLevelLoss": [
        "group_id",
        "level_id",
        "cohort",
        "unique_booster_count",
        "unique_booster_type",
        "offer_id"
    ],
    "UniqueBoosterEnd": [
        "offer_id",
        "unique_booster_type",
        "cohort",
        "unique_booster_count"
    ],
    "progressSize": [
        "size"
    ],
    "BundleDownloadStart": [
        "bundle_name",
        "type"
    ],
    "BundleDownloadSuccess": [
        "bundle_name",
        "type"
    ],
    "attStatus": [
        "att_status",
        "ios_version",
        "session_version"
    ],
    "attCheckStatus": [
        "att_status",
        "session_version"
    ],
    "BundleDeleted": [
        "cache_key",
        "last_manifest_entry_id"
    ],
    "lowMemory": [
        "total_ram",
        "game_ram"
    ],
    "minuteEvent": [
        "minute"
    ],
    "clansJoinOffersRequest": [
        "request_id"
    ],
    "clansJoinOffersAnswer": [
        "request_id",
        "clans_number_in_set",
        "response_time"
    ],
    "startSession": [
        "sessionPerDay",
        "ulives",
        "lives",
        "smart_cohort",
        "smart_cohort_previous",
        "change_reason"
    ],
    "ServerSynchronizationOk": [
        "sync_type"
    ],
    "contentEnd": [
        "content_id",
        "content_type",
        "reason"
    ],
    "contentStartSuccess": [
        "content_id",
        "content_type",
        "content_start",
        "content_end"
    ],
    "winstreakTournamentPromoPopUpShow": [
        "offer_id",
        "cohort",
        "bot_cohort"
    ],
    "piggyBankTurnOff": [
        "piggy_level",
        "full",
        "ruby_count",
        "reason",
        "offer_id"
    ],
    "MenuClick": [
        "menu_id"
    ],
    "inboxSeen": [
        "news_id",
        "news_type"
    ],
    "startWindowClickSync": [
        "source"
    ],
    "schemeClick": [
        "link",
        "source"
    ],
    "socialLogin": [
        "type",
        "source"
    ],
    "ServerSynchronizationSynchro": [
        "sync_type",
        "cm_social_id",
        "global_user_id"
    ],
    "ServerSynchronizationSyncPopupShow": [
        "sync_type",
        "cm_social_id",
        "global_user_id"
    ],
    "ServerSynchronizationSyncPopupClose": [
        "reason_close",
        "cm_social_id",
        "global_user_id"
    ],
    "ServerSynchronizationConfirmPopupClose": [
        "reason_close",
        "cm_social_id",
        "global_user_id"
    ],
    "buildDataSize": [
        "size"
    ],
    "clanLeave": [
        "reason",
        "clan"
    ],
    "startedAbtest": [
        "ab_test"
    ],
    "finishedAbtest": [
        "ab_test"
    ],
    "bpNewEventFinish": [
        "offer_id"
    ],
    "teamRaceTeamBuild": [
        "friends",
        "clan",
        "other",
        "auto_match",
        "team_id",
        "team_cohort",
        "offer_id",
        "cohort"
    ],
    "teamRaceStageStart": [
        "team_id",
        "team_cohort",
        "stage",
        "offer_id",
        "cohort"
    ],
    "teamRaceWindowOpen": [
        "offer_id",
        "cohort"
    ],
    "seTimeEventInfoShow": [
        "offer_id",
        "cohort",
        "global_user_id"
    ],
    "stagedTournamentWindowOpen": [
        "offer_id",
        "cohort"
    ],
    "stagedTournamentTokenGet": [
        "cohort",
        "stage",
        "amount",
        "offer_id"
    ],
    "stagedTournamentStageEnd": [
        "cohort",
        "stage",
        "place",
        "stage_tokens",
        "offer_id"
    ],
    "stagedTournamentStageStart": [
        "cohort",
        "stage",
        "offer_id"
    ],
    "stagedTournamentEnd": [
        "cohort",
        "place",
        "tournament_tokens",
        "offer_id"
    ],
    "qsQuestGet": [
        "client_cohort",
        "quest_priority",
        "quest_number",
        "stage_number",
        "quest_name",
        "quest_place_name",
        "amount",
        "offer_id",
        "cohort"
    ],
    "deviceScreenOrientation": [
        "orientation"
    ],
    "socialExit": [
        "type"
    ],
    "changedAbtest": [
        "ab_test",
        "global_user_id"
    ],
    "temporaryTownsEventComicsStart": [
        "offer_id",
        "cohort"
    ],
    "tournamentEnter": [
        "tournament",
        "league",
        "leaderboard"
    ],
    "leaderboardAssigned": [
        "tournament",
        "leaderboard_id",
        "league",
        "matchmaking_cohort"
    ],
    "wcLeaderboardAssign": [
        "leaderboard_id",
        "offer_id",
        "bundle_id",
        "cohort"
    ],
    "profileHudClick": [
        "cohort",
        "global_user_id"
    ],
    "profileGamerOpen": [
        "cohort",
        "global_user_id"
    ],
    "loadingScreen": [
        "route"
    ],
    "firstLaunchLoadingComplete": [
        "time"
    ],
    "tutorialInitial": [
        "route"
    ],
    "shsEventMonthClansStart": [
        "offer_id"
    ],
    "unlockCollection": [
        "type"
    ],
    "userReferrer": [
        "referrer"
    ],
    "gamedataUpdated": [
        "hash"
    ],
    "UniqueBoosterMainWindow": [
        "unique_booster_type",
        "unique_booster_count",
        "cohort",
        "offer_id"
    ],
    "InboxImportantNewsShow": [
        "news_id",
        "news_type"
    ],
    "InboxImportantNewsExit": [
        "news_id",
        "news_type"
    ],
    "seTimeEventClickStart": [
        "offer_id",
        "cohort",
        "loop"
    ],
    "seTimeWarningPopupShow": [
        "offer_id",
        "cohort"
    ],
    "seTimeWarningStartClick": [
        "offer_id",
        "cohort"
    ],
    "seTimeTimerStart": [
        "offer_id",
        "cohort"
    ],
    "seTimeEventWindowOpen": [
        "offer_id",
        "cohort"
    ],
    "scMarkGet": [
        "type",
        "star",
        "gold",
        "source",
        "collection",
        "offer_id",
        "cohort"
    ],
    "UniqueBoosterActivate": [
        "unique_booster_count",
        "unique_booster_type",
        "cohort",
        "offer_id"
    ],
    "showDailyBonus": [
        "with_ads",
        "type"
    ],
    "shsEventMonthClansFinish": [
        "offer_id",
        "cheater",
        "place_player",
        "total_amount_player",
        "players_count",
        "clans_count"
    ],
    "onboardingFlowStart": [
        "cohort",
        "onboarding_restart",
        "onboarding_replace",
        "saga_wins",
        "onboarding_saga_wins",
        "lifetime_revenue",
        "days_from_last_login"
    ],
    "minigameBriefing": [
        "level_id",
        "level_type",
        "house_id",
        "offer_id",
        "cohort"
    ],
    "seTimeEventClick": [
        "offer_id",
        "cohort"
    ]
}
